import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Redefinepatientservices() {
  return (
    <section className="redefinepatient_services p-100 tekgrip_section on_demand_services">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={8} xxl={8}>
            <h2>
              Our <span>On Demand App</span> Development Services Include
            </h2>
            <p>
              Get an on demand service delivery app deployed on your preferred
              application marketplaces with zero hassle and see immediate
              results. Our reliable on demand app development company offers
              full-cycle business solutions – meaning your app is built to
              complement user personas, boost brand engagement, and rev up
              sales.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book a Call
            </Link>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. On-Demand App Consulting
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. On-Demand Mobile App Development Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            03. On-Demand Web App Development Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. On-Demand Cross-Platform App Development
                            Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            05. Ongoing App Support & Maintenance
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="5">06. Upscale & Expand</Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/on_demand_consulting.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={49}
                          />
                        </div>
                        <h3>On-Demand App Consulting</h3>
                        <p>
                          Got a unique app idea? Our end-to-end on-demand mobile
                          app development service begins with idea consultation
                          and prospecting multi-dimensional digital growth
                          channels. Our business analysts and product
                          technologists are here to help you map the app
                          development progress. From how the app looks to how it
                          functions, our expert on-demand app developers help
                          you decide on the features and tech stacks.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/mobile_app-development.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>On-Demand Mobile App Development Services</h3>
                        <p>
                          We build apps for over 15 industries. Whether your
                          goal is to go native (iOS or Android) or reach users
                          across OSes with cross-platform deployment, our
                          on-demand app development services offer complete
                          flexibility. Following the pre-development ideation,
                          our extensive mobile app development unit creates
                          appealing interfaces and a powerful backend for a
                          successful launch.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/web_app_development.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>On-Demand Web App Development Services</h3>
                        <p>
                          Boost brand engagement with our progressive web app
                          development services. Bypass app store downloads and
                          reach users directly through their browsers.
                          Leveraging Workbox and Lighthouse, we build accessible
                          PWAs that provide offline access, enable push
                          notifications, and ensure secure data handling for a
                          seamless and reliable user experience across all
                          devices.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/cross_platform.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={48}
                            height={48}
                          />
                        </div>
                        <h3>
                          On-Demand Cross-Platform App Development Services
                        </h3>
                        <p>
                          Become more accessible to your targeted users with a
                          one-for-all platform. Our on-demand app development
                          services enable multi-channel launches with a single
                          codebase, providing an equally dynamic experience as a
                          native app. Cross-platform development ensures
                          consistent performance, faster time-to-market, and
                          reduced costs. Using React Native and Flutter, we
                          deliver seamless updates and maintenance, keeping your
                          app cutting-edge and reliable.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/support.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Ongoing App Support & Maintenance</h3>
                        <p>
                          To keep the app running at 100% potential is as
                          important as any of the core pre-launch phases.
                          Whether it’s evolving user needs or platform
                          (Android/iOS) updates, our on-demand app development
                          services extend support post-launch. We offer
                          continuous monitoring, performance optimization, and
                          regular updates to adapt to new OS versions and user
                          feedback to ensure your app remains reliable, secure,
                          and up-to-date.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="5">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/solution/on-demand-new/scale_up.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Upscale & Expand</h3>
                        <p>
                          Scale your app seamlessly as your user base grows. Our
                          on-demand app development services provide robust
                          scalability features to handle increased traffic and
                          user demands effortlessly. We implement microservices
                          architecture, auto-scaling, and cloud integration to
                          ensure high availability and performance. With our
                          expert mobile app developers expand the app’s features
                          and capabilities, adapting to market trends and user
                          feedback without compromising quality or speed.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Redefinepatientservices;
